import { render, staticRenderFns } from "./openMiniApp.vue?vue&type=template&id=c3f22cee&scoped=true&"
import script from "./openMiniApp.vue?vue&type=script&lang=js&"
export * from "./openMiniApp.vue?vue&type=script&lang=js&"
import style0 from "./openMiniApp.vue?vue&type=style&index=0&id=c3f22cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f22cee",
  null
  
)

export default component.exports